'use strict';

import SelectPrice from './components/SelectPrice.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('select-price', SelectPrice);

    }
}